// Vendors
import React from 'react';
// Constants
import { LANDING_OPTIONS_LAYOUT_SELECTOR_COMPONENT_PROPS } from './constants/landing-options.constants';
// Components
import { SelectorRowComponent } from '@openbank/ziniaweb-ui-components';
import { LandingOptionsCenterContentComponent } from './components/center-content/landing-options-center-content.component';
import { LandingOptionsLeftContentComponent } from './components/left-content/landing-options-left-content.component';
import { LandingOptionsModalComponent } from './components/modal/landing-options-modal.component';
// Hooks
import { useLandingOptionsHook } from './hooks/landing-options.hook';
// Styles
import {
  LandingOptionsComponentStyled,
  LandingOptionsListComponentStyled,
  LandingOptionsListItemComponentStyled,
} from './landing-options.component.styled';
// Types
import {
  LandingOptionsComponentType,
  LandingOptionsOptionComponentType,
} from './types/landing-options.component.type';
// Utilities
import { landingMethodIsSelected } from './utils/landing-options.utils';

const LandingOptionsComponent = <T,>({
  modalConfiguration,
  options,
  onSelectMethod,
  selectedMethod,
}: LandingOptionsComponentType<T>): React.JSX.Element => {
  const { handleCloseLandingMethodModalEvent: onClose, showMethodModal } = useLandingOptionsHook<T>(
    { selectedMethod, modalConfiguration }
  );

  return (
    <LandingOptionsComponentStyled>
      <LandingOptionsListComponentStyled>
        {options.map(({ description, icon, type, title }: LandingOptionsOptionComponentType<T>) => (
          <LandingOptionsListItemComponentStyled key={title}>
            <SelectorRowComponent
              {...LANDING_OPTIONS_LAYOUT_SELECTOR_COMPONENT_PROPS}
              custom={{
                centerContent: (
                  <LandingOptionsCenterContentComponent<T> {...{ description, title }} />
                ),
                leftContent: <LandingOptionsLeftContentComponent<T> {...{ icon }} />,
              }}
              onClick={() => onSelectMethod(type)}
              selected={landingMethodIsSelected<T>({ type, selectedMethod })}
            />
          </LandingOptionsListItemComponentStyled>
        ))}
      </LandingOptionsListComponentStyled>
      <LandingOptionsModalComponent<T>
        {...{ modalConfiguration, onClose, showMethodModal, selectedMethod }}
      />
    </LandingOptionsComponentStyled>
  );
};

export { LandingOptionsComponent };
